import type { OfApi } from '../../ofApi'
import type { StreamingMe } from './streamingData'

/** What every part of the Streaming page gets from StreamingPage. */
export interface StreamingCtx {
  accountId: string
  of: OfApi
  /** users/me as the page needs it. */
  me: StreamingMe
  /** May change things (schedule, edit, delete); false disables every control. */
  canWrite: boolean
  mobile: boolean
  /** Another view of this page (`''` dashboard, `view=create`, `edit=<id>`). */
  go: (query: string, replace?: boolean) => void
  /** Another CRM page of this Account. */
  openPage: (page: string, query?: string, opts?: { replace?: boolean }) => void
  say: (text: string) => void
}

/** OnlyFans' error message from a failed call. */
export function errorText(e: unknown, fallback: string): string {
  if (e && typeof e === 'object') {
    const err = e as { message?: unknown; error?: { message?: unknown }; detail?: unknown }
    if (typeof err.error?.message === 'string' && err.error.message) return err.error.message
    if (typeof err.message === 'string' && err.message) return err.message
    if (typeof err.detail === 'string' && err.detail) return err.detail
  }
  return fallback
}
